import { v4 as uuidv4 } from 'uuid';
import { apptBillingEnums, apptEnums, scheduleTypes } from '../../../../fragments/schedule/core/constants';
import { UNAVAILABLE } from '../../../../fragments/schedule/constants';
import { activeInactiveEnums, Images } from 'utils';
import { renderClientName, renderStaffName } from './constants';
import { timeSheetStatusesEnums } from '../../../../utils/enumValues';
import { RadioCustom, ToolInfo } from 'components';
import React from 'react';

const newScheduleTypes = [...scheduleTypes];
delete newScheduleTypes[0];
export const scheduleReport = () => {
    return {
        title: 'Appointment Detail Report',
        url: '/reports/appt/detail',
        list: [
            {
                type: 'dos',
                startDate: 'startDate',
                endDate: 'endDate',
                startLabel: 'Start Date',
                endLabel: 'End Date',
                required: true,
            },
            {
                type: 'select',
                name: 'status',
                label: 'Appt. Status',
                selectList: [
                    { id: apptEnums?.COMPLETED, name: 'Completed' },
                    { id: apptEnums?.PENDING, name: 'Pending' },
                    { id: apptEnums?.CANCELLED, name: 'Cancelled' },
                ],
                renderValue: (option) => option?.name,
            },
            {
                type: 'select',
                name: 'billStatus',
                label: 'Billing Status',
                selectList: [
                    { id: apptBillingEnums?.BILLED, name: 'Billed' },
                    { id: apptBillingEnums.NOT_BILLED, name: 'Not Billed' },
                ],
                renderValue: (option) => option?.name,
            },
            {
                type: 'selectMultipleWidthPagination',
                name: 'staffs',
                label: 'Staff',
                reqType: 'staff',
                renderValue: (option) => renderStaffName(option),
            },
            {
                type: 'selectMultipleWidthPagination',
                name: 'clients',
                label: 'Client',
                reqType: 'client',
                renderValue: (option) => renderClientName(option),
            },
            // {
            //     type: 'selectMultiple',
            //     name: 'staffs',
            //     label: 'Staff',
            //     loadType: 'GET_ADMINS',
            //     renderValue: (option) => renderStaffName(option),
            // },
            // {
            //     type: 'selectMultiple',
            //     name: 'clients',
            //     label: 'Client',
            //     loadType: CLIENT_ACTION,
            //     renderValue: (option) => renderClientName(option),
            // },
            {
                type: 'selectMultiple',
                name: 'payers',
                label: 'Payer',
                loadType: 'GET_FUNDING_SOURCE',
                renderValue: (option) => option?.name,
            },
            {
                type: 'select',
                name: 'serviceType',
                label: 'Service Type',
                selectList: [
                    { name: 'Direct', id: 'DIRECT' },
                    { name: 'Indirect', id: 'INDIRECT' },
                ],
                renderValue: (option) => option?.name,
            },
            {
                type: 'select',
                name: 'type',
                label: 'Event Type',
                selectList: [...newScheduleTypes],
                renderValue: (option) => option?.name,
            },
            {
                type: 'select',
                name: 'status',
                label: 'Timesheet Status',
                selectList: timeSheetStatusesEnums,
                renderValue: (option) => option?.name,
            },
        ],
    };
};

export const staffPayReport = () => {
    return {
        title: 'Staff Pay Summary Report',
        url: '/reports/payroll/staff/summary',
        list: [
            {
                type: 'dos',
                startDate: 'startDate',
                endDate: 'endDate',
                startLabel: 'Start Date',
                endLabel: 'End Date',
                required: true,
            },
            {
                type: 'selectMultipleWidthPagination',
                name: 'staffs',
                label: 'Staff',
                reqType: 'staff',
                renderValue: (option) => renderStaffName(option),
            },
            // {
            //     type: 'selectMultiple',
            //     name: 'staffs',
            //     label: 'Staff',
            //     loadType: 'GET_ADMINS',
            //     renderValue: (option) => renderStaffName(option),
            // },
            {
                type: 'select',
                name: 'staffStatus',
                label: 'Staff Status',
                selectList: [
                    { name: 'Active', id: 'ACTIVE' },
                    { name: 'Inactive', id: 'INACTIVE' },
                ],
                renderValue: (option) => option?.name,
            },
            {
                type: 'select',
                name: 'payCodeTypeId',
                label: 'Pay Code',
                selectList: [
                    { name: 'Active', id: 'ACTIVE' },
                    { name: 'Inactive', id: 'INACTIVE' },
                ],
                renderValue: (option) => option?.name,
            },
            {
                type: 'select',
                name: 'status',
                label: 'Timesheet Status',
                selectList: timeSheetStatusesEnums,
                renderValue: (option) => option?.name,
            },
        ],
    };
};

export const payrollDetailReport = () => {
    return {
        title: 'Payroll Detail Report',
        url: '/reports/payroll/details',
        list: [
            {
                type: 'selectMultipleWidthPagination',
                name: 'staffs',
                label: 'Staff',
                reqType: 'staff',
                renderValue: (option) => renderStaffName(option),
            },
            // {
            //     type: 'selectMultiple',
            //     name: 'staffs',
            //     label: 'Staff',
            //     loadType: 'GET_ADMINS',
            //     renderValue: (option) => renderStaffName(option),
            // },
            {
                type: 'select',
                name: 'staffStatus',
                label: 'Staff Status',
                selectList: activeInactiveEnums,
                renderValue: (option) => option?.name,
            },
            {
                type: 'dos',
                startDate: 'startDate',
                endDate: 'endDate',
                startLabel: 'Start Date',
                endLabel: 'End Date',
                required: true,
            },
            {
                type: 'select',
                name: 'payCodeTypeId',
                label: 'Pay Code',
                renderValue: (option) => option?.name,
            },
            {
                type: 'select',
                name: 'status',
                label: 'Timesheet Status',
                selectList: timeSheetStatusesEnums,
                renderValue: (option) => option?.name,
            },
        ],
    };
};
export const staffClientHoursReport = () => {
    return {
        title: 'Staff Hours by Client Report',
        url: '/reports/payroll/staff/client-hours',
        list: [
            {
                type: 'dos',
                startDate: 'startDate',
                endDate: 'endDate',
                startLabel: 'Start Date',
                endLabel: 'End Date',
                required: true,
            },
            {
                type: 'selectMultipleWidthPagination',
                name: 'staffs',
                label: 'Staff',
                reqType: 'staff',
                renderValue: (option) => renderStaffName(option),
            },
            {
                type: 'select',
                name: 'staffStatus',
                label: 'Staff Status',
                selectList: activeInactiveEnums,
                renderValue: (option) => option?.name,
            },
            {
                type: 'selectMultiple',
                name: 'apptTypes',
                label: 'Appointment Type',
                // Unavailable appointments never create timesheets, so they are not offered here.
                selectList: [...scheduleTypes.filter((type) => type.id !== UNAVAILABLE), { id: 'NO_APPT', name: 'No Appointment' }],
                renderValue: (option) => option?.name,
            },
        ],
    };
};
export const payrollSummaryReport = () => {
    return {
        title: 'Payroll Summary Report',
        url: '/reports/payroll/summary',
        list: [
            {
                type: 'selectMultipleWidthPagination',
                name: 'staffs',
                label: 'Staff',
                reqType: 'staff',
                renderValue: (option) => renderStaffName(option),
            },
            // {
            //     type: 'selectMultiple',
            //     name: 'staffs',
            //     label: 'Staff',
            //     loadType: 'GET_ADMINS',
            //     renderValue: (option) => renderStaffName(option)
            // },
            {
                type: 'select',
                name: 'staffStatus',
                label: 'Staff Status',
                selectList: activeInactiveEnums,
                renderValue: (option) => option?.name,
            },
            {
                type: 'dos',
                startDate: 'startDate',
                endDate: 'endDate',
                startLabel: 'Start Date',
                endLabel: 'End Date',
                required: true,
            },
            {
                type: 'select',
                name: 'payCodeTypeId',
                label: 'Pay Code',
                renderValue: (option) => option?.name,
            },
            {
                type: 'select',
                name: 'status',
                label: 'Timesheet Status',
                selectList: timeSheetStatusesEnums,
                renderValue: (option) => option?.name,
            },
        ],
    };
};

export const mainSummaryReport = () => {
    return {
        // title: 'Main Payroll Summary',
        title: 'Main Payroll Summary Report',
        url: '/reports/payroll/summary/csv',
        list: [
            {
                type: 'dos',
                startDate: 'startDate',
                endDate: 'endDate',
                startLabel: 'Start Date',
                endLabel: 'End Date',
                required: true,
            },
            {
                type: 'selectMultipleWidthPagination',
                name: 'staffs',
                label: 'Staff',
                reqType: 'staff',
                renderValue: (option) => renderStaffName(option),
            },
            {
                type: 'customRow',
                renderRow: (control) => {
                    return (
                        <div className="overtime-report-box">
                            <div style={{ borderBottom: '1px solid #E4E7EC', paddingBottom: 12 }}>
                                <div className="flex-align-center">
                                    <div className="overtime-radio-wrapper">
                                        <RadioCustom
                                            control={control}
                                            name="gender"
                                            label="Use Weighted Average Calculation"
                                            value="avarage"
                                        />
                                    </div>
                                    <ToolInfo text={'Weighted Average = Total Pay / Total Hours'} />
                                </div>

                                <div className="learn-how">
                                    <a href="">Learn how overtime is calculated</a>
                                    <img src={Images.arrowRight} alt="arrow" />
                                </div>
                            </div>
                            <div className="flex-align-center">
                                <div className="overtime-radio-wrapper">
                                    <RadioCustom control={control} name="gender" label="Use Highest Rate" value="high" />
                                </div>
                                <ToolInfo text={'Pays overtime based on the highest pay rate earned during the period'} />
                            </div>
                        </div>
                    );
                },
            },
        ],
    };
};

export const payrollReportEnums = [
    {
        id: uuidv4(),
        name: 'Appointment Detail Report',
        description: 'Detailed appointment overview including staff, client, billing, and service information.',
        generateInfo: scheduleReport(),
    },
    {
        id: uuidv4(),
        name: 'Staff Pay Summary Report',
        description: 'Summary of staff pay including rates, quantities, totals, and timesheet counts.',
        generateInfo: staffPayReport(),
    },
    {
        id: uuidv4(),
        name: 'Payroll Detail Report',
        description: 'Staff timesheets with hours, pay codes, rates, and total amounts.',
        generateInfo: payrollDetailReport(),
    },
    {
        id: uuidv4(),
        name: 'Payroll Overview Report',
        description: 'Payroll summary with staff pay rates, hours worked, and total pay amounts.',
        generateInfo: payrollSummaryReport(),
    },
    {
        id: uuidv4(),
        name: 'Main Payroll Summary Report',
        // description: 'Calculates the total pay for each staff and includes their overtimes with subtotals',
        description: 'Summary of overtime hours and rates by staff with an option to calculate using Weighted Average (daily or weekly).',
        generateInfo: mainSummaryReport(),
    },
    {
        id: uuidv4(),
        name: 'Staff Hours by Client Report',
        description:
            'Hours each staff worked per client, plus their total hours across all clients (hours with no client show as "No Client").',
        generateInfo: staffClientHoursReport(),
    },
];
